import { useQuery } from "@tanstack/react-query";
import $api from "@/zapi-frontend/shared/api/axios";

export type TUserLanguage = "english" | "japanese";

export type TUserPreferences = {
  uiLanguage: TUserLanguage;
};

export function useUserPreferences() {
  return useQuery({
    queryKey: ["userPreferences"],
    queryFn: async (): Promise<TUserPreferences> => {
      const response = await $api.get<{ data: TUserPreferences; message: string }>("/user/preferences");
      return response.data.data;
    }
  });
}
